import { Link } from 'react-router-dom';
import { Sprout, Heart } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-9 h-9 bg-white/10 rounded-xl flex items-center justify-center">
                <Sprout className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading font-semibold text-xl">RaiseRoot</span>
            </Link>
            <p className="text-primary-200 text-sm leading-relaxed">
              The fundraising professional's toolkit. Find grants, write winning proposals, manage funder relationships, and grow your mission.
            </p>
          </div>

          {/* Templates */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Templates</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/templates?category=corporate-sponsorship" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Corporate Sponsorship
                </Link>
              </li>
              <li>
                <Link to="/templates?category=email-marketing" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Email Marketing
                </Link>
              </li>
              <li>
                <Link to="/templates?category=donation-letters" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Donation Letters
                </Link>
              </li>
              <li>
                <Link to="/templates?category=grant-proposals" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Grant Proposals
                </Link>
              </li>
            </ul>
          </div>

          {/* More Templates */}
          <div>
            <h4 className="font-semibold mb-4 text-white">More</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/templates?category=social-media" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Social Media
                </Link>
              </li>
              <li>
                <Link to="/templates?category=volunteer-recruitment" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Volunteer Recruitment
                </Link>
              </li>
              <li>
                <Link to="/templates?category=event-planning" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Event Planning
                </Link>
              </li>
              <li>
                <Link to="/templates" className="text-primary-200 hover:text-white text-sm transition-colors">
                  All Templates
                </Link>
              </li>
            </ul>
          </div>

          {/* Account & Support */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Account & Support</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/login" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Log In
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Sign Up
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Help & Feedback
                </Link>
              </li>
              <li>
                <Link to="/consulting" className="text-primary-200 hover:text-white text-sm transition-colors">
                  Book a Strategy Session
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-primary-800 mt-8 pt-8 space-y-3">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-primary-300 text-sm">
              &copy; {currentYear} RaiseRoot. All rights reserved.
            </p>
            <p className="text-primary-300 text-sm flex items-center gap-1">
              Made with <Heart className="w-4 h-4 text-secondary fill-secondary" /> for nonprofits
            </p>
          </div>
          <p className="text-primary-400 text-xs text-center">
            RaiseRoot is owned and operated by Strategic Fundraising Consulting LLC
          </p>
        </div>
      </div>
    </footer>
  );
};
